import { Box } from '@mui/material';

import {
  ConnectionTitle,
  Section,
  SectionTitle,
  StatusItem,
  StatusValue,
} from './styles';

import { useWebRTCLiveStats } from 'features/analytics/hooks/';

export const LiveStatsTab = () => {
  const { connectionStats, isStatsAvailable } = useWebRTCLiveStats(true);

  if (!isStatsAvailable) {
    return (
      <Section>
        <SectionTitle variant='subtitle2'>Connection Stats (Live)</SectionTitle>
        <StatusItem>
          Status: <StatusValue>No active connections</StatusValue>
        </StatusItem>
      </Section>
    );
  }

  return (
    <Section>
      <SectionTitle variant='subtitle2'>Connection Stats (Live)</SectionTitle>
      {Object.entries(connectionStats).map(([peerId, stats], index) => {
        const shortPeerId = peerId.split('@')[0] || `Peer ${index + 1}`;

        if (!stats) {
          return (
            <Box key={peerId} mb={2}>
              <ConnectionTitle variant='body2'>{shortPeerId}</ConnectionTitle>
              <StatusItem>
                Status: <StatusValue>No data available</StatusValue>
              </StatusItem>
            </Box>
          );
        }

        return (
          <Box key={peerId} mb={2}>
            <ConnectionTitle variant='body2'>{shortPeerId}</ConnectionTitle>
            <StatusItem>
              Video FPS (In/Out):{' '}
              <StatusValue>
                {Math.round(stats.inboundVideoFps * 10) / 10} /{' '}
                {Math.round(stats.outboundVideoFps * 10) / 10}
              </StatusValue>
            </StatusItem>
            <StatusItem>
              Video Jitter:{' '}
              <StatusValue>
                {Math.round(stats.videoJitter * 1000) / 1000}ms
              </StatusValue>
            </StatusItem>
            <StatusItem>
              Audio Jitter:{' '}
              <StatusValue>
                {Math.round(stats.audioJitter * 1000) / 1000}ms
              </StatusValue>
            </StatusItem>
            <StatusItem>
              Round Trip Time:{' '}
              <StatusValue>{Math.round(stats.roundTripTime)}ms</StatusValue>
            </StatusItem>
            <StatusItem>
              Packet Loss:{' '}
              <StatusValue>
                {Math.round(stats.packetLossRate * 100) / 100}%
              </StatusValue>
            </StatusItem>
            <StatusItem>
              Video Bitrate:{' '}
              <StatusValue>{stats.videoBitrate} kbps</StatusValue>
            </StatusItem>
            <StatusItem>
              Video Resolution (In/Out):{' '}
              <StatusValue>
                {stats.inboundVideoResolution} / {stats.outboundVideoResolution}
              </StatusValue>
            </StatusItem>
          </Box>
        );
      })}
    </Section>
  );
};
